export const SystemId = {
  SystemTenantID: 'C0AC7829-545C-4ADC-871B-84BC392ABAD9',
  FedExCompanyID: 'ECCCBB41-B97C-42C4-B476-AF718E973D54',
  PrePassCompanyID: 'BE4C03AB-5E6A-4984-AD42-E61E712192EB',
  RyderCompanyId: 'D955F1FA-FAF6-49B2-A213-D429CB78B494',
  EmptyGuidId: '00000000-0000-0000-0000-000000000000'
};
